/**
 * RequireAuth — guard de autenticação (Req 1, DD-005, RNF 1).
 *
 * Redireciona para /login quando o usuário não está autenticado.
 * Salva a rota corrente em `azim.route` (safeStorage) para restauração após login.
 */

import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../AuthProvider.js";
import { safeStorage } from "../../adapters/storage/safeStorage.js";
import type { ReactNode } from "react";

interface RequireAuthProps {
  children: ReactNode;
}

export function RequireAuth({ children }: RequireAuthProps) {
  const { user, sessionState } = useAuth();
  const location = useLocation();

  // Durante a inicialização (authenticating com usuário ainda nulo), aguarda.
  // sessionState === "authenticated" é a única condição de acesso.
  if (sessionState === "authenticating") {
    // Renderiza nada durante a validação inicial — evita flash de redirect
    return null;
  }

  if (!user || sessionState === "unauthenticated" || sessionState === "expired") {
    // Persiste rota para restauração após login (azim.route em safeStorage)
    safeStorage.setItem("azim.route", location.pathname);
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
